export const PAGE_SIZE_ITEM = 'pageSize';
export const SEARCH_SORTING_SETTINGS_KEY = 'sortingSettings';
export const SHARE_SORTING_SETTINGS_KEY = 'shareSortingSettings';
export const POD_SIZE_ITEM = 'podWidth';
export const IS_NAVBAR_EXPANDED = 'isNavbarExpanded';
export const COMMENT_DOWNLOADS_WORDS_PER_LINE = 'commentDownloadsWordsPerLine';
export const TRANSCRIPTION_DOWNLOADS_WORDS_PER_LINE =
  'transcriptionDownloadsWordsPerLine';
export const REVIEW_EXPERIENCE_OPT_OUT_PER_SHARE =
  'reviewExperienceOptOutPerShare';
export const SHOW_ASSET_SELECTOR_STORAGE_KEY = 'showAssetSelectorPortalId';
export const PORTAL_GALLERY_WIDTH = 'portalGalleryWidth';
export const PORTAL_GALLERY_OPEN = 'portalGalleryOpen';
export const PORTAL_GALLERY_VIEW_MODE = 'portalGalleryViewMode';
export const PORTAL_PANEL_WIDTH = 'portalPanelWidth';
export const PORTAL_THEMES_TIP_DISMISSED = 'portalThemesTipDismissed';
export const AI_METADATA_ENRICHMENT_LIST_WIDTH =
  'aiMetadataEnrichmentListWidth';
export const NLTF_SEARCH_MODE = 'nltfSearchMode';
export const NATURAL_SEARCH_REPLAY = 'naturalSearchReplay';
